import { useTranslation } from 'react-i18next';
import { useLanguage } from '@/context/LanguageContext';
import { Globe } from 'lucide-react';

export default function LandingNav({ onCta }) {
  const { t } = useTranslation();
  const { language, setLanguage } = useLanguage();

  const toggleLang = () => setLanguage(language === 'es' ? 'en' : 'es');

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass border-b border-gray-200/50 dark:border-gray-800/50">
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-brand-500 to-accent-500 flex items-center justify-center text-white font-bold text-sm">
            K2
          </div>
          <span className="font-display font-bold text-lg text-gray-900 dark:text-white">
            Kuadra2
          </span>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={toggleLang}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
          >
            <Globe size={16} />
            {language === 'es' ? 'EN' : 'ES'}
          </button>
          <button onClick={onCta} className="btn-primary text-sm py-2 px-5">
            {t('landing.hero.cta')}
          </button>
        </div>
      </div>
    </nav>
  );
}
